import mapKeys from "lodash/mapKeys";
import fontFamilies from "PFTheme/tokens/fontFamilies";
import fontSizes from "PFTheme/tokens/fontSizes";
import fontWeights from "PFTheme/tokens/fontWeights";
import letterSpacings from "PFTheme/tokens/letterSpacings";
import lineHeights from "PFTheme/tokens/lineHeights";
import radii from "PFTheme/tokens/radii";
import spacing from "PFTheme/tokens/spacing";

import { getColorStyles } from "./load_design_tokens.utils";

export const loadDesignTokens = () => {
  const tokensFlatMap = {
    ...fontFamilies,
    ...fontSizes,
    ...fontWeights,
    ...letterSpacings,
    ...lineHeights,
    ...radii,
    ...spacing
  };

  const { rootStyles, darkStyles } = getColorStyles();

  const styleElement = document.createElement("style");
  styleElement.textContent = rootStyles + darkStyles;
  document.head.appendChild(styleElement);

  mapKeys(tokensFlatMap, (value, key) => {
    document.documentElement.style.setProperty(`--${key}`, String(value));
  });
};
